export const Colors = {
  blue: '#015BBB',
  yellow: '#FED500',
  white: '#ffffff',
  black: '#161616',
};
